import React from 'react';
import { useIntl } from 'umi';
import { Icon } from 'tea-component';
import { useTokenUsageQuota } from '@/pages/aigc/layouts/agentLayout/hooks';
import ChartPopoverTitleTip from '@/pages/aigc/pages/Agent/components/QAInput/ChartPopover/components/ChartPopoverTitleTip';
import TokenProgressBar from './components/TokenProgressBar';
import quotaIcon from '@/pages/aigc/assets/svg/agent-quota-icon.svg';
import './index.scss';

const TokenUsageQuota = () => {
  const { formatMessage } = useIntl();
  const { percentage, loading } = useTokenUsageQuota({manual: false});

  const isExceeded = percentage >= 100;

  return (
    <div
      className={`dba-token-usage-quota${isExceeded ? ' dba-token-usage-quota--exceeded' : ''}`}
    >
      <div className="dba-token-usage-quota__glass" aria-hidden="true" />
      <div className="dba-token-usage-quota__body">
        <div className="dba-token-usage-quota__header">
          <img
            className="dba-token-usage-quota__quota-icon"
            src={quotaIcon}
            alt=""
          />
          <span className="dba-token-usage-quota__title">
            {formatMessage({ id: 'dba_token_monthly_quota' })}
          </span>
          <ChartPopoverTitleTip
            content={formatMessage({ id: 'dba_token_quota_tooltip' })}
            overlayClassName="dba-token-quota-tooltip"
          />
          <div className="dba-token-usage-quota__header-right">
            {loading ? (
              <Icon type="loading" />
            ) : (
              <>
                <span
                  className={`dba-token-usage-quota__percentage${
                    isExceeded ? ' dba-token-usage-quota__percentage--danger' : ''
                  }`}
                >
                  {percentage.toFixed(1)}%
                </span>
              </>
            )}
          </div>
        </div>
        <TokenProgressBar percent={percentage} className="dba-token-usage-quota__progress" />
      </div>
      <div className="dba-token-usage-quota__divider" />
    </div>
  );
};

export default React.memo(TokenUsageQuota);
